<template lang="pug">
  footer
    .container(v-if="!isMobile")
      .footer-left.col-md-6
        img.footer-logo(src="~assets/footer-logo.png")
        ul
          li WirForce 2017 Presented By 4Gamers.
          li Copyright © 2017 4Gamers Taiwan. All Rights Reserved.
      //- .footer-right.col-md-6
        ul
          li 合辦單位：臺北市政府產發局
          li 合辦單位：國貿局
          li 協辦單位：臺灣電競協會
          li 協辦單位：臺北市政府資訊局
    .container(v-else)
      .footer-left.col-md-6
        img.footer-logo(src="~assets/footer-logo.png")
        //- ul
          li 合辦單位：臺北市政府產發局
          li 合辦單位：國貿局
          li 協辦單位：臺灣電競協會
          li 協辦單位：臺北市政府資訊局
      .footer-right.col-md-6
        ul
          li WirForce 2017 Presented By 4Gamers.
          li Copyright © 2017 4Gamers Taiwan. All Rights Reserved.
</template>

<script>
export default {
  name: 'footer',
  beforeRouteEnter (to, from, next) {
  },
  props: {
    isMobile: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
footer
  position: relative
  bottom: 0
  width: 100%
  background-color: #0a0b0d
  padding: 32px 16px 24px 16px
  .container
    margin-top: 0
  ul
    list-style: none
    padding-left: 0
    font-weight: bold
  .footer-logo
    margin-bottom: 16px
  .footer-right
    color: $grey
    margin-top: 16px
    li
      margin-bottom: 3px
</style>



// WEBPACK FOOTER //
// vueFooter.vue?b8480908